<template>
  <div class="m-r-10">
    <div class="tabs">
      <v-tabs v-model="tab" centered fixed-tabs class="m-b-10">
        <v-tab
          v-for="item in itemsTab"
          :id="item"
          :key="item"
          class="font-size-sub"
          v-on:click="tabClick(item)"
        >
          {{ item }}
        </v-tab>
      </v-tabs>

      <div v-show="currentTab === 'Pages'">
        <component-page
          :tabs="tabs"
          :structure="structure"
          :tabSelected="tabSelected"
          :isEnableBackward="isEnableBackward"
          :isEnableForward="isEnableForward"
          @backward="backward"
          @forward="forward"
          @setupStructure="setupStructure"
          @pageClick="pageClick"
          @pageCreate="pageCreate"
          @pageCloneFromTemplate="pageCloneFromTemplate"
          @pageSaveAsTemplate="pageSaveAsTemplate"
          @pageConfirmRemove="pageConfirmRemove"
          @pageRename="pageRename"
        ></component-page>
      </div>
      <div v-show="currentTab === 'Search'">
        <component-search
          :ui="ui"
          :currentTab="currentTab"
          :tabSelected="tabSelected"
          :nodeSelected="nodeSelected"
          @pageClick="pageClick"
          @componentClick="componentClick"
        ></component-search>
      </div>
    </div>
  </div>
</template>

<script>
import ComponentPage from './components/page'
import ComponentSearch from './components/search'

export default {
  components: {
    ComponentPage,
    ComponentSearch
  },
  props: {
    ui: Object,
    tabs: Array,
    structure: Array,
    tabSelected: String,
    nodeSelected: Object,
    isEnableBackward: Boolean,
    isEnableForward: Boolean
  },
  data() {
    return {
      tab: null,
      currentTab: 'Pages',
      itemsTab: ['Pages', 'Search']
    }
  },
  methods: {
    async tabClick(item) {
      this.currentTab = item
    },
    backward() {
      this.$emit('backward', null)
    },
    forward() {
      this.$emit('forward', null)
    },
    setupStructure(data) {
      this.$emit('setupStructure', data)
    },
    componentClick(data) {
      this.$emit('componentClick', data)
    },
    pageClick(data) {
      this.$emit('pageClick', data)
    },
    pageCreate(data) {
      this.$emit('pageCreate', data)
    },
    pageCloneFromTemplate(data) {
      this.$emit('pageCloneFromTemplate', data)
    },
    pageSaveAsTemplate(data) {
      this.$emit('pageSaveAsTemplate', data)
    },
    pageConfirmRemove(data) {
      this.$emit('pageConfirmRemove', data)
    },
    pageRename(data) {
      this.$emit('pageRename', data)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-slide-group {
  height: 40px !important;
}
</style>
